export const ADD_PARENT_BOOKING = 'PARENT_BOOKING';
export const ADD_CHILD_BOOKING = 'ADD_CHILD_BOOKING';

export const REMOVE_PARENT_BOOKING = 'REMOVE_PARENT_BOOKING';
export const REMOVE_CHILD_BOOKING = 'REMOVE_CHILD_BOOKING';

export const CATEGORY_FLIGHTS = 'Flights';
export const CATEGORY_ACCOMODATION = 'Accommodation (Hotel)';
export const CATEGORY_PACKAGES = 'Package';
export const CATEGORY_VISA = 'Visa';
export const CATEGORY_INSURANCE = 'Insurance';
